<div style="padding: 15px;">
    <button mat-raised-button color="primary" (click)="addEinOrgInfo()" *ngIf="tableType === 'exception'">Add
        Organization</button>
</div>
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px"
    [@routeAnimation]="true">
    <div fxLayout="column">
        <mat-form-field class="filter">
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" [value] = "einFilter">
        </mat-form-field>
    </div>
    <div fxLayout="column" class="mat-elevation-z8 table-container">
        <mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="EIN">
                <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> EIN </mat-header-cell>
                <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.ein}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="orgName">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Org Name </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.organization_name}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="subsection_501">
                <mat-header-cell style="flex-grow: 1.5;" *matHeaderCellDef mat-sort-header> Tax Exempt Status
                </mat-header-cell>
                <mat-cell style="flex-grow: 1.5;" *matCellDef="let row"> {{getTaxExemptStatus(row.subsection_501)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="address1">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Address1 </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.address_line1}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="address2">
                <mat-header-cell style="flex-grow: 2;" fxFlex="15" *matHeaderCellDef mat-sort-header> Address2
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" fxFlex="15" *matCellDef="let row"> {{row.address_line2}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="city">
                <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> City </mat-header-cell>
                <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.city}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="state">
                <mat-header-cell style="flex-grow: 0.5;" *matHeaderCellDef mat-sort-header> State </mat-header-cell>
                <mat-cell style="flex-grow: 0.5;" *matCellDef="let row"> {{row.state}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="zipCode">
                <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> Zip Code </mat-header-cell>
                <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.zip}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="validationStatus">
                <mat-header-cell style="flex-grow: 0.75;" *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                <mat-cell style="flex-grow: 0.75;" *matCellDef="let row"
                    [ngStyle]="{'color': row.isValid? '#388E3C': 'red'}">
                    {{row.isValid? 'Valid': 'Expired'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="lastUpdated">
                <mat-header-cell style="flex-grow: 1.25;" *matHeaderCellDef mat-sort-header> Last Verify Date
                </mat-header-cell>
                <mat-cell style="flex-grow: 1.25;" *matCellDef="let row">
                    {{row.lastUpdated | date: 'MM-dd-yyyy h:mm:ss a'}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="action">
                <mat-header-cell style="flex-grow: 0.5;" *matHeaderCellDef mat-sort-header> </mat-header-cell>
                <mat-cell style="flex-grow: 0.5" *matCellDef="let row">
                    <button mat-icon-button matTooltip="Delete entry" matTooltipShowDelay="200"
                        color="warn" (click)="onDelete(row)">
                        <mat-icon>delete_forever</mat-icon>
                    </button></mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"> </mat-row>
        </mat-table>
    </div>
    <div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</div>